<grid-with-search
  [gridData]="tagsList"
  [gridColumns]="gridColumns"
  (deleteGridItem)="deleteTag($event)"
  (addNewGridItem)="addTag($event)"
  (editGridItem)="updateTag($event)"
  [enableSwitchTooltip]="enableSwitchTooltip"
  [SearchPlaceHolder]="SearchPlaceHolder"
  [editableMaxLength]="editableMaxLength"
  [isParentContainerTags]="true"
  [NoDataText]="NoDataText"
  [isNameCaseSensitive]="true"
  [deleteLabel]="deleteLabel"
  [deleteConfirmationMessage]="deleteConfirmationMessage"
  (bulkDeleteGridItems)="bulkDeleteTags($event)"
></grid-with-search>